module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    mode: { default: null }

  computed:

    partners: ->
      @.$store.state.partners.partners

    cssClasses: ->
      "list-#{@mode}"

  methods:

    onImageLoaded: ->
      @.$emit 'imageLoaded'


// WEBPACK FOOTER //
// ./assets/js/frontend/components/partners_slider/components/image_group/index.coffee